module.exports = __webpack_public_path__ + "img/MyChoice2201_BAC.140dc8db.jpg";